// Generate mock customer orders with random restaurants from store
export const generateMockCustomerOrders = (restaurants) => {
  if (!restaurants || restaurants.length === 0) {
    return [];
  }

  const getRandomRestaurant = () => {
    return restaurants[Math.floor(Math.random() * restaurants.length)];
  };

  return [
    {
      id: 1,
      date: "2026-01-10",
      restaurant: getRandomRestaurant(),
      meal_name: "Piletina sa povrćem",
      quantity: 1,
      price: 8.50,
      total: 8.50,
    },
    {
      id: 2,
      date: "2026-01-10",
      restaurant: getRandomRestaurant(),
      meal_name: "Čorba",
      quantity: 1,
      price: 3.00,
      total: 3.00,
    },
    {
      id: 3,
      date: "2026-01-09",
      restaurant: getRandomRestaurant(),
      meal_name: "Ćevapi sa lepinjom",
      quantity: 2,
      price: 3.50,
      total: 7.00,
    },
    {
      id: 4,
      date: "2026-01-09",
      restaurant: getRandomRestaurant(),
      meal_name: "Grah sa kobasicom",
      quantity: 1,
      price: 6.50,
      total: 6.50,
    },
    {
      id: 5,
      date: "2026-01-08",
      restaurant: getRandomRestaurant(),
      meal_name: "Riba sa rižom",
      quantity: 1,
      price: 12.00,
      total: 12.00,
    },
    {
      id: 6,
      date: "2026-01-08",
      restaurant: getRandomRestaurant(),
      meal_name: "Shopska salata",
      quantity: 1,
      price: 4.50,
      total: 4.50,
    },
    {
      id: 7,
      date: "2026-01-05",
      restaurant: getRandomRestaurant(),
      meal_name: "Pasta carbonara",
      quantity: 1,
      price: 9.50,
      total: 9.50,
    },
    {
      id: 8,
      date: "2026-01-04",
      restaurant: getRandomRestaurant(),
      meal_name: "Pileća supa",
      quantity: 1,
      price: 3.50,
      total: 3.50,
    },
    {
      id: 9,
      date: "2026-01-04",
      restaurant: getRandomRestaurant(),
      meal_name: "Musaka",
      quantity: 1,
      price: 7.50,
      total: 7.50,
    },
    {
      id: 10,
      date: "2026-01-03",
      restaurant: getRandomRestaurant(),
      meal_name: "Sendvič sa šunkom",
      quantity: 1,
      price: 4.00,
      total: 4.00,
    },
  ].map(order => ({
    ...order,
    restaurant_name: order.restaurant.name,
    restaurant_id: order.restaurant.id,
  }));
};
